import { render } from "./portfolio-details.vue?vue&type=template&id=47cda8ee&scoped=true&ts=true"
import script from "./portfolio-details.vue?vue&type=script&lang=ts"
export * from "./portfolio-details.vue?vue&type=script&lang=ts"

import "./portfolio-details.vue?vue&type=style&index=0&id=47cda8ee&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47cda8ee"]])

export default __exports__